var initGoogleLogin = function () {
	if (typeof sGoogleAppId !== "undefined" && sGoogleAppId !== "")
	{
		google.accounts.id.initialize({
			client_id: sGoogleAppId,
			callback: handleCredentialResponse
		});

		if($(el("btnGoogleLogin")).length > 0) google.accounts.id.renderButton(document.getElementById("btnGoogleLogin"),{ theme: "outline", size: "large" });
		if($(el("btnGoogleLoginIdentify")).length > 0) google.accounts.id.renderButton(document.getElementById("btnGoogleLoginIdentify"),{ theme: "outline", size: "large" });
		if($(el("btnGoogleRegister")).length > 0) google.accounts.id.renderButton(document.getElementById("btnGoogleRegister"),{ theme: "outline", size: "large" });
	}
}

function handleCredentialResponse(response)
{
	clearInlineErrors();

	$("body #btnGoogleLogin, body #btnGoogleLoginIdentify, body #btnGoogleRegister").prop('disabled', true).addClass("loading");

	var bValid = false;
	if($(el("frmRegister")).length > 0)
	{
		bValid = validateCheckbox($(el("frmRegister")));

		if(!bValid)
		{
			inlineAlert('error',tAcceptTermsError, false, $(el("btnGoogleRegister")),false);
		}
	}
	else
	{
		bValid = true;
	}

	if(bValid)
	{
		var sParams = '&credential=' + response.credential + "&type=google";
		uAjax = "/index.cfm/customer/ajax/social";
		var oCall = callAjax("social", sParams, "post");

		// process result
		oCall.success(function (oData) {
			if (oData.errorType == '') {
				if (typeof sRedirect !== 'undefined' && sRedirect !== '') {
					if (sRedirect.indexOf("/quickcheckout") >= 0)
					{
						sRedirect += '/true/true/' + oData.email;
					}
					window.location = sRedirect;
				}
				else {
					window.location = '/' + sCurrentLanguageCode + '/transaction';
				}
			}
			else {
				$("body #btnGoogleLogin, body #btnGoogleLoginIdentify, body #btnGoogleRegister").prop('disabled', false).removeClass("loading");
				if($(el("btnGoogleLogin")).length > 0) inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el("btnGoogleLogin")));
				if($(el("btnGoogleLoginIdentify")).length > 0) inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el("btnGoogleLoginIdentify")));
				if($(el("btnGoogleRegister")).length > 0) inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el("btnGoogleRegister")));
			}
		});
	}
	else
	{
		$("body #btnGoogleLogin, body #btnGoogleLoginIdentify, body #btnGoogleRegister").prop('disabled', false).removeClass("loading");
	}
}